import { startOfDay } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

/**
 * Gets the minimum allowed date for calendar selection and availability requests.
 * This ensures consistency between UI constraints (Calendar minDate) and server constraints.
 *
 * @param now - Current date/time
 * @param customerTimeZone - Customer's timezone
 * @returns Minimum allowed date (start of today in customer's timezone)
 */
export const getMinimumAllowedDate = (now: Date, customerTimeZone: string): Date => {
  return startOfDay(utcToZonedTime(now, customerTimeZone))
}

/**
 * Gets the minimum allowed date in UTC for server requests.
 * Clamps to start of current month in UTC to match server constraints.
 *
 * @param now - Current date/time (JavaScript Date object - internally stored as UTC timestamp)
 * @returns Minimum allowed date in UTC (start of current month)
 */
export const getMinimumAllowedDateUtc = (now: Date): Date => {
  // Date objects are stored as UTC internally, so getUTCFullYear() and getUTCMonth()
  // correctly extract UTC values, which is what we need for server constraints
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1, 0, 0, 0, 0))
}
